import {Tab, Tabs, TabsProps} from '@mui/material';

import React, {useEffect} from 'react';
import AurIcon, {IconColors, IconNames} from '../../common/aur-icon/AurIcon';

export interface ITabIconLabel {
  tabIndex: number,
  label: string | React.ReactNode;
  icon: IconNames;
}

interface Props extends TabsProps {
  defaultTabIndex?: number;
  onSelectTabIndex?: (tabIndex: number) => void;
  iconLabelArray: ITabIconLabel[];
  classNames?: string;
}

const AurTabWithIcons: React.FC<Props> = (props: Props) => {
  const {
    defaultTabIndex = 0,
    onSelectTabIndex,
    iconLabelArray,
    classNames,
    ...rest
  } = props;

  const [selectedTabIndex, setSelectedTabIndex] =
    React.useState(defaultTabIndex);

  const onChangeTabIndex = (_: React.SyntheticEvent, index: number) => {
    onSelectTabIndex?.(index);
    setSelectedTabIndex(index);
  };

  useEffect(() => {
    if (defaultTabIndex != selectedTabIndex) {
      setSelectedTabIndex(defaultTabIndex);
    }
  }, [defaultTabIndex]);

  return (
    <Tabs
      className={`aurTabWithIcons ${classNames}`}
      value={selectedTabIndex}
      onChange={onChangeTabIndex}
      {...rest}
    >
      {iconLabelArray.map((item: ITabIconLabel, index: number) => (
        <Tab
          key={item.label?.toString()}
          data-testid={`tab-${index}`}
          icon={
            <AurIcon
              icon={item.icon}
              color={IconColors.Custom}
              customClassName={'aurTab-icon'}
            />
          }
          label={item.label}
          wrapped
        />
      ))}
    </Tabs>
  );
};

export default AurTabWithIcons;
